const SIZE_TABLE_DATA = {
  newSize: {
    titleKey: 'PDP_SIZE_TABLE_NEWSIZE_TEXT',
    default: 'New Size',
  },
  oldSize: {
    titleKey: 'PDP_SIZE_TABLE_OLDSIZE_TEXT',
    default: 'Old Size',
  },
}

export default SIZE_TABLE_DATA
